/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Test_SuccessInputs */

const en_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live captioning connection test succeeded.`)
};

const fr_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de connexion au sous-titrage en direct réussi.`)
};

const de_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Verbindungstest für die Live-Untertitelung war erfolgreich.`)
};

const it_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test di connessione per i sottotitoli in tempo reale riuscito.`)
};

const ru_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка подключения для трансляции субтитров в реальном времени прошла успешно.`)
};

const es_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prueba de conexión para subtítulos en directo se ha realizado correctamente.`)
};

const zh_cn2_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕连接测试成功。`)
};

const ja_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブ字幕接続テストに成功しました。`)
};

const hi_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग कनेक्शन परीक्षण सफल रहा।`)
};

const pt_pt2_live_caption_test_success = /** @type {(inputs: Live_Caption_Test_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teste de conexão de legendas ao vivo foi bem-sucedido.`)
};

/**
* | output |
* | --- |
* | "Live captioning connection test succeeded." |
*
* @param {Live_Caption_Test_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_test_success = /** @type {((inputs?: Live_Caption_Test_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Test_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_test_success(inputs)
	if (locale === "de") return de_live_caption_test_success(inputs)
	if (locale === "it") return it_live_caption_test_success(inputs)
	if (locale === "ru") return ru_live_caption_test_success(inputs)
	if (locale === "es") return es_live_caption_test_success(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_test_success(inputs)
	if (locale === "ja") return ja_live_caption_test_success(inputs)
	if (locale === "hi") return hi_live_caption_test_success(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_test_success(inputs)
	return en_live_caption_test_success(inputs)
});